module.exports = __webpack_public_path__ + "static/media/template-answer.87b75d22.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svg/template-answer.svg
// module id = 822
// module chunks = 0